import React from 'react';

class SurveyClients extends React.Component {
    render(){
        return(
            <section className="clients"><h2 className="clients__title">Клиенты</h2>
                <div className="clients__block">
                    <div className="clients__img-wrap"><img className="clients__img" src="images/client-1.jpg" alt=""
                                                            role="presentation"/></div>
                    <div className="clients__img-wrap"><img className="clients__img" src="images/client-2.jpg" alt=""
                                                            role="presentation"/></div>
                    <div className="clients__img-wrap"><img className="clients__img" src="images/client-3.jpg" alt=""
                                                            role="presentation"/></div>
                    <div className="clients__img-wrap"><img className="clients__img" src="images/client-4.jpg" alt=""
                                                            role="presentation"/></div>
                    <div className="clients__img-wrap"><img className="clients__img" src="images/client-5.jpg" alt=""
                                                            role="presentation"/></div>
                </div>
            </section>
        )
    }
}

export default SurveyClients;


// WEBPACK FOOTER //
// ./src/Components/SurveyStudio/SurveyClients.js